const accessiblePart = (value, kind) => {
    const normalized = String(value === undefined || value === null ? '' : value)
        .replace(/\s+/g, ' ')
        .trim()
    if (!normalized) throw new TypeError(`${kind} is required for an accessible action name`)
    return normalized
}

export const createIconActionName = (operation, recordIdentifier) =>
    `${accessiblePart(operation, 'Operation')} ${accessiblePart(recordIdentifier, 'Record identifier')}`

const elementFor = value => (value && value.current ? value.current : value)

export const isAvailableFocusTarget = value => {
    const element = elementFor(value)
    if (!element || typeof element.focus !== 'function') return false
    if (element.disabled || element.getAttribute('aria-hidden') === 'true') return false
    return typeof element.isConnected !== 'boolean' || element.isConnected
}

export const restoreDialogFocus = (opener, fallback) => {
    const openerElement = elementFor(opener)
    if (isAvailableFocusTarget(openerElement)) {
        openerElement.focus()
        return openerElement
    }
    const fallbackElement = elementFor(fallback)
    if (isAvailableFocusTarget(fallbackElement)) {
        fallbackElement.focus()
        return fallbackElement
    }
    return null
}

export const queueDialogFocusRestoration = (opener, fallback) => {
    const restore = () => restoreDialogFocus(opener, fallback)
    if (typeof requestAnimationFrame === 'function') return requestAnimationFrame(restore)
    return setTimeout(restore, 0)
}
